import { useQuery } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "usehooks-ts";

export interface FeatureAnnouncement {
	id: string;
	title: string;
	description: string;
	actionUrl?: string;
	actionText?: string;
}

export const useFeatureAnnouncement = () => {
	const { t } = useTranslation();
	const [latestViewedFeature, setLatestViewedFeature] = useLocalStorage("latest-viewed-feature", "");

	const { data: latestFeature } = useQuery({
		queryKey: ["latestFeature"],
		queryFn: () => {
			return {
				id: "backup",
				title: t("newFeatures.sync.backup.title"),
				description: t("newFeatures.sync.backup.description"),
				actionUrl: "/sync-folder",
				actionText: t("newFeatures.sync.downloadSyncFolder"),
			};
		},
	});

	const shouldShowAnnouncement = useMemo(() => {
		if (!latestFeature) return false;
		return latestFeature?.id !== latestViewedFeature;
	}, [latestFeature, latestViewedFeature]);

	const markAsViewed = useCallback(() => {
		setLatestViewedFeature(latestFeature?.id ?? "");
	}, [latestFeature, setLatestViewedFeature]);

	return { shouldShowAnnouncement, markAsViewed, latestFeature };
};
